import React, { useContext, useEffect, useState } from "react";
import { TextContrato } from "#/components/TextContrato";
import {
  Button,
  Loader,
  Paragraph,
  Modal,
  Spacing,
  Title,
} from "@sicredi/react";
import styles from "./styles.module.scss";
import { ButtonLinkChevronRight } from "#/components/ButtonLinkChevronRight";
import { ContextAPI } from "#/contextProver/ContextProver";
import { useNavigate } from "react-router-dom";
import { PAGE } from "#/constants";
import { getVendasListaProposta } from "#/api/getVendasListaProposta";
import ImgAplicativoSicredi from "../../assets/ilSicredi_app_200px.png";
import ImgAplicativoSicredi1 from "../../assets/ilSicredi_app_200px.png";
import ImgPersonal from "../../assets/il_personal_info_200.png";
import ImgGroup from "../../assets/Group.png";
import ImgBloqueioAoAbrirConta from "../../assets/Bloqueio ao abrir conta.png";
import { cancelarProposta } from "#/api/cancelarProposta";

export const Contract: React.FC = () => {
  const {
    codigoComissionado,
    documento,
    idDocumento,
    setVendasListaProposta,
    isLoading,
    setIsLoading,
  } = useContext(ContextAPI);
  const navigate = useNavigate();

  const handleButtonMobile = () => {
    navigate(PAGE.ROOT);
    setTimeout(() => {
      handleGoAppStorePropostaAceita();
    }, 1000);
  };

  const handleCancelarProposta = async () => {
    setIsLoading(true);
    try {
      await cancelarProposta({
        codigoComissionado,
        documento,
        idDocumento,
      });

      const vendasListaProposta = await getVendasListaProposta({
        codigoComissionado,
        documento,
      });
      setVendasListaProposta(vendasListaProposta);

      setIsLoading(false);
      setIsOpenModalCancelar(false);
      navigate(PAGE.ROOT);
    } catch {
      setIsLoading(false);
      setIsOpenModalCancelar(false);
    }
  };
  const [isOpenModalCancelar, setIsOpenModalCancelar] = useState(false);

  const handleGoAppStorePropostaAceita = () => {
    const userAgent = navigator.userAgent;
    const iOS = !!userAgent.match(/iPhone|iPad|iPod/);
    const isAndroid = /android/i.test(userAgent);
    let url = "";

    if (isAndroid) {
      url =
        "https://play.google.com/store/apps/details?id=br.com.sicredimobi.smart";
    } else if (iOS) {
      url =
        "https://apps.apple.com/br/app/sicredi-para-smartphone/id1041468908";
    } else {
      url = "https://www.sicredi.com.br/";
    }
    window.location.href = url;
  };

  useEffect(() => {
    if (!codigoComissionado) {
      navigate(PAGE.ROOT);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className={styles.container}>
      <Loader show={isLoading} fullScreen />
      <img className={styles.img} src={ImgAplicativoSicredi} alt="App Imagem" />
      <Spacing appearance="small" />
      <Title as="h1" className={styles.title}>
        Seu contrato está pronto para assinatura
      </Title>
      <Paragraph size="small" weight="normal" className={styles.paragraph}>
        Para concluir a assinatura, basta acessar o{" "}
        <strong>aplicativo Sicredi</strong> e seguir alguns passos simples.
        Assim, você garante que seu contrato esteja válido e pronto para a
        próxima etapa da contratação.
      </Paragraph>
      <Spacing appearance="small" />
      <TextContrato
        order={1}
        img={ImgAplicativoSicredi1}
        description={
          <span>
            <strong>Abra o aplicativo Sicredi</strong> e faça login na sua
            conta.
          </span>
        }
      />
      <Spacing appearance="small" />
      <TextContrato
        order={2}
        img={ImgPersonal}
        description={
          <span>
            Toque no ícone de <strong>mensagens</strong> no canto superior
            direito da tela inicial.
          </span>
        }
      />
      <Spacing appearance="small" />
      <TextContrato
        order={3}
        img={ImgGroup}
        description={
          <span>
            Em seguida, selecione <strong>"Mensagens"</strong> e encontre o
            contrato pendente.
          </span>
        }
      />
      <Spacing appearance="small" />
      <TextContrato
        order={4}
        img={ImgBloqueioAoAbrirConta}
        description={
          <span>
            Leia os termos, confira as informações e{" "}
            <strong>assine digitalmente</strong> para finalizar.
          </span>
        }
      />
      <Spacing appearance="small" />
      <div className={styles.button_cancelar_contrato}>
        <ButtonLinkChevronRight
          text="Cancelar proposta"
          onClick={() => setIsOpenModalCancelar(true)}
          marginTop={0}
        />
      </div>
      <Modal
        title="Deseja cancelar a proposta?"
        onClose={() => setIsOpenModalCancelar(false)}
        show={isOpenModalCancelar}
        secondaryButton={{
          children: "Sim",
          onClick: async () => handleCancelarProposta(),
        }}
        primaryButton={{
          children: "Não",
          onClick: () => setIsOpenModalCancelar(false),
        }}
      >
        Tem certeza que deseja cancelar sua proposta?
      </Modal>

      <Button
        onClick={() => handleButtonMobile()}
        appearance="primary"
        block={true}
        className={styles.button_contratar}
      >
        Abrir aplicativo do Sicredi
      </Button>
    </div>
  );
};
